// Smooth announcement-bar offset for the homepage overlay header.
// --header-top tracks the bar's live bottom edge as it scrolls, clamped at 0.
// This eliminates the gap+snap caused by a static top offset.
(function () {
  if (!document.body.classList.contains('homepage') &&
      !document.body.classList.contains('life-of-many-colors')) return;
  var bar = document.querySelector('.utility-bar');
  if (!bar) return;
  var root = document.documentElement;
  function update() {
    root.style.setProperty('--announcement-bar-h', bar.offsetHeight + 'px');
    root.style.setProperty('--header-top', Math.max(0, bar.getBoundingClientRect().bottom) + 'px');
  }
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  window.addEventListener('load', update);
})();

// ============================================================
// CONTENT CAROUSEL — RELIABLE ARROW DISABLE + VERTICAL CENTERING
//
// Strategy: IntersectionObserver (IO) watching the first and last
// .slider__slide within the scroll track. IO fires reliably after
// scroll-snap settles — independent of scroll-event timing — so
// "on the last slide → next disabled" is guaranteed every time.
//
// .carousel-arrow--disabled is the single source of truth for the
// faded/non-interactive state (CSS targets this class only, not
// [disabled], so Dawn's page-math can never cause false fades).
//
// Vertical centering: re-run after every image load so arrows sit
// at the midpoint of the card image on every breakpoint.
// ============================================================
(function () {
  'use strict';

  // ── Toggle disabled state (class is the CSS hook; attribute for a11y) ─────
  function setDisabled(btn, isDisabled) {
    if (isDisabled) {
      btn.classList.add('carousel-arrow--disabled');
      btn.setAttribute('aria-disabled', 'true');
    } else {
      btn.classList.remove('carousel-arrow--disabled');
      btn.removeAttribute('aria-disabled');
    }
  }

  // ── Arrow vertical centering ───────────────────────────────────────────────
  function centerArrows(component) {
    var prevBtn = component.querySelector('button[name="previous"]');
    var nextBtn = component.querySelector('button[name="next"]');
    if (!prevBtn || !nextBtn) return;

    var firstSlide = component.querySelector('.slider__slide');
    if (!firstSlide) return;

    var cardInner = firstSlide.querySelector('.card__inner');
    if (!cardInner) return;

    var imageHeight = cardInner.offsetHeight;
    if (imageHeight === 0) return;

    var btnHeight = prevBtn.getBoundingClientRect().height || 44;
    var topOffset = Math.round((imageHeight / 2) - (btnHeight / 2));
    prevBtn.style.top = topOffset + 'px';
    nextBtn.style.top = topOffset + 'px';
  }

  // ── Initialise each content-carousel slider-component ─────────────────────
  function initCarousel(component) {
    if (component.dataset.customArrowsInit) return;
    component.dataset.customArrowsInit = '1';

    var sliderEl = component.querySelector('[id^="Slider-"]');
    var prevBtn  = component.querySelector('button[name="previous"]');
    var nextBtn  = component.querySelector('button[name="next"]');
    if (!sliderEl || !prevBtn || !nextBtn) return;

    var slides = Array.prototype.slice.call(component.querySelectorAll('.slider__slide'));
    if (!slides.length) return;

    var firstSlide = slides[0];
    var lastSlide  = slides[slides.length - 1];

    // Track live intersection ratios for first and last slides
    var firstRatio = 0;
    var lastRatio  = 0;

    // Apply disabled state based on current ratios + scrollLeft fallback
    function apply() {
      var sl        = sliderEl.scrollLeft;
      var maxScroll = sliderEl.scrollWidth - sliderEl.clientWidth;

      // Non-scrollable (only 1 card, or track not wide enough)
      if (maxScroll <= 2) {
        setDisabled(prevBtn, true);
        setDisabled(nextBtn, true);
        return;
      }

      // Prev: disabled when first slide is fully visible OR at scroll start
      setDisabled(prevBtn, firstRatio >= 0.98 || sl <= 2);

      // Next: disabled when last slide is fully visible OR at scroll end
      setDisabled(nextBtn, lastRatio >= 0.98 || sl >= maxScroll - 2);
    }

    // IntersectionObserver — root is the scroll track so ratios are
    // relative to the visible scroll port, not the viewport.
    // threshold array gives us fine-grained ratio updates.
    var thresholds = [];
    for (var i = 0; i <= 100; i++) { thresholds.push(i / 100); }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === firstSlide) firstRatio = entry.intersectionRatio;
        if (entry.target === lastSlide)  lastRatio  = entry.intersectionRatio;
      });
      apply();
    }, {
      root: sliderEl,
      threshold: thresholds
    });

    io.observe(firstSlide);
    io.observe(lastSlide);

    // Also run apply() on scroll (catches sub-pixel cases IO misses)
    // and re-asserts our class over Dawn's [disabled] toggling.
    sliderEl.addEventListener('scroll', apply, { passive: true });

    // Re-check on resize
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        apply();
        centerArrows(component);
      }, 100);
    });

    // Initial state
    apply();

    // Arrow vertical centering — run now and after every image load
    centerArrows(component);
    component.querySelectorAll('img').forEach(function (img) {
      if (img.complete) {
        centerArrows(component);
      } else {
        img.addEventListener('load', function () { centerArrows(component); });
      }
    });
  }

  // ── Wait for slider-components to be defined and connected ────────────────
  function initAll() {
    document.querySelectorAll(
      'slider-component[data-slider-type="content-carousel"]'
    ).forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('load', initAll);

  if (window.MutationObserver) {
    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('slider-component[data-slider-type="content-carousel"]')) {
            initCarousel(node);
          }
          node.querySelectorAll && node.querySelectorAll(
            'slider-component[data-slider-type="content-carousel"]'
          ).forEach(initCarousel);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
